import { Grid, Typography } from '@mui/material';
import { CheckboxItem } from 'lib/designSystem/CheckBoxItem';
import React from 'react';

import type {
  ExtensionCheckboxesSetters,
  ExtensionCheckboxesState,
} from '../hooks/useExtensionCheckboxes';

interface ExtensionCheckboxesProps {
  checkboxes: ExtensionCheckboxesState;
  setters: ExtensionCheckboxesSetters;
}

export const ExtensionCheckboxes: React.FC<ExtensionCheckboxesProps> = ({
  checkboxes,
  setters,
}) => {
  const {
    showDocumentInfo = true,
    showExtensionInfo = true,
    showDates = true,
    showParamsAndCosts = true,
    showObservation = true,
    showDocumentFinancials = true,
    showPendingAccounts = true,
  } = checkboxes;

  const {
    setShowDocumentInfo,
    setShowExtensionInfo,
    setShowDates,
    setShowParamsAndCosts,
    setShowObservation,
    setShowDocumentFinancials,
    setShowPendingAccounts,
  } = setters;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 'bold', mb: 1, mt: 2 }}
        >
          Información del documento
        </Typography>
        <CheckboxItem
          label="Folio, cliente y deudor"
          checked={showDocumentInfo}
          onChange={setShowDocumentInfo}
        />
        <CheckboxItem
          label="ID y estado de la prórroga"
          checked={showExtensionInfo}
          onChange={setShowExtensionInfo}
        />
        <CheckboxItem
          label="Fechas (inicio, vencimiento, creación)"
          checked={showDates}
          onChange={setShowDates}
        />
        <CheckboxItem
          label="Montos del documento (liberación, abonos, saldo)"
          checked={showDocumentFinancials}
          onChange={setShowDocumentFinancials}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 'bold', mb: 1, mt: 2 }}
        >
          Parámetros y observaciones
        </Typography>
        <CheckboxItem
          label="Tasa y costos"
          checked={showParamsAndCosts}
          onChange={setShowParamsAndCosts}
        />
        <CheckboxItem
          label="Observaciones"
          checked={showObservation}
          onChange={setShowObservation}
        />
        <CheckboxItem
          label="Cuentas por cobrar (tabla)"
          checked={showPendingAccounts}
          onChange={setShowPendingAccounts}
        />
      </Grid>
    </Grid>
  );
};
